
import React from 'react';
import { MessageCircle } from 'lucide-react';

const ConversationTab: React.FC = () => {
  return (
    <div className="p-6">
      <div className="flex items-center gap-2 mb-4">
        <MessageCircle className="h-5 w-5 text-blue-500" />
        <h3 className="text-lg font-medium">Conversation</h3>
      </div>
      
      <div className="bg-gray-50 p-8 rounded-md text-center">
        <p className="text-gray-500">Aucun commentaire pour cette vidéo</p>
        <p className="text-sm text-gray-400">Les commentaires apparaîtront ici une fois qu'ils seront publiés</p>
      </div>
    </div>
  );
};

export default ConversationTab;
